module.exports = {"transport":"http","websocket":"ws://gnexportal.com:9876","uri":"http://gnexportal.com:9000","url":"","dev_uri":"http://gnexportal.com:9000","stage_uri":"http://gnexportal.com:9000","address_prefix":"GNX","chain_id":"b3f32f410037a129b990f29230698048fe895e23e7dc297fd6f6e9d167a62571"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1